import * as Config from '../../../config';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from "react-redux";
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { DragContext } from '../../../contexts/drag-context';

import useNCItemList from "../nav-control/hooks/useNCItemList";

import {
  setTickItemID
} from "../../../actions/index";

function DragItem({
  type, item, style, idParent,
  begin, end, onClick, onMouseEnter = null, partialGrab = false,
  className, children,
  dnd = true
}) {
  const [, dragRef, preview] = useDrag({
    item: { ...item, type, idParent },
    begin: begin,
    end: end
  })
  const dispatch = useDispatch();

  // Custom Ghost with CustomDragLayerWrapper - Slow with HTML5Backend
  useEffect(() => { // HTML5 USE BUT TOUCH NO NEED
    preview(getEmptyImage(), { captureDraggingState: true })
  }, [preview])

  const isTick = useSelector( state => (state.tickItemID && state.tickItemID === `DI-${item.id}-TRACK`) );
  useEffect(() => {
    if (isTick) {
      setTimeout( () => {
        const el = document.getElementById(`DI-${item.id}-TRACK`);
        if (el) {
          el.scrollIntoView();
          el.style.border = `1px solid ${Config.BRAND_PRIMARY}`; //`1px solid #7217FF`;
          setTimeout( () => { 
            el.style.border = null;
            dispatch(setTickItemID(null))
          }, 2000);
        }
      }, 500);
    }
  }, [isTick, item.id, dispatch])

  useNCItemList(idParent, item);

  const onRightClick = (e) => {
    const el = document.getElementById(`more-ref-${item.id}`);
    (el) && el.click();
  }

  // const isSelected = useSelector( state => (state.selectedItems && !!state.selectedItems.find(x => x.id === item.id) )); //OLD V1
  // V2
  const [selected, setSelected] = useState(false);
  const isSelected = useSelector( state => (state.selectedItems && !!state.selectedItems.find(x => x.id === item.id) ) )
  useEffect(() => {
    setSelected(isSelected);
  }, [isSelected])
 
  return (
    <DragContext.Provider value={{ dragRef }}>
      <div id={`DI-${item.id}-${type}`} ref={ (!partialGrab && !Config.TOUCH_ENABLED && dnd) ? dragRef : null } onClick={onClick} onContextMenu={onRightClick}
        onMouseEnter={(onMouseEnter) ? onMouseEnter : null}
        style={{ ...style }} className={`${className} ${selected && `selected`}`} >
        { React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {})
          }
        }) }
      </div>
    </DragContext.Provider>
  );
}

DragItem.propTypes = {
  type: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  style: PropTypes.object,
  idParent: PropTypes.any,
  begin: PropTypes.func.isRequired,
  end: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string
}

export default DragItem;
